import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://jzywrnhfrxlnsbktnnwo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6eXdybmhmcnhsbnNia3RubndvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5MDkyNTYsImV4cCI6MjA2OTQ4NTI1Nn0.rBJLEOk2lL8johUMFqdnukJx8wrp1VXf-fa6AnHk6vs'

// Singleton pattern - tek bir client instance
let supabaseInstance: ReturnType<typeof createClient> | null = null

export const supabase = (() => {
  if (!supabaseInstance) {
    if (!supabaseUrl) {
      throw new Error('Supabase URL is required. Please check your environment variables.')
    }
    if (!supabaseAnonKey) {
      throw new Error('Supabase Anon Key is required. Please check your environment variables.')
    }
    
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        storageKey: 'petunyaborek-auth'
      }
    })
  }
  return supabaseInstance
})()